export const setUnits = (listUnit) => {
    return {
        type: 'LIST_UNIT',
        listUnit,
    };
};

export const setUnit = (unit) => {
    return {
        type: 'SET_UNIT',
        unit
    };
};

export const resetFilters = () => {
    return {
        type: 'RESET_FILTER',
    };
};

export const setUnitOrdering = (listUnitOrdering) => {
    return {
        type: 'LIST_UNIT_ORDERING',
        listUnitOrdering,
    };
};

